import axios from "axios";

export default {
    state: {
        addressTypes: [],
        filter: {}
    },
    getters: {
        ADDRESS_TYPES: state => {
            return state.addressTypes;
        },
        ADDRESS_TYPES_FILTER: state => {
            return state.filter;
        }
    },
    mutations: {
        SET_ADDRESS_TYPES: (state, payload) => {
            state.addressTypes = payload;
        },
    },
    actions: {
        GET_ADDRESS_TYPES: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios
                  .get(`addressTypes`)
                  .then(({ data, status }) => {
                    if (status === 200) {
                        commit("SET_ADDRESS_TYPES", data);
                        resolve(true);
                    }
                  })
                  .catch(error => {
                    reject(error);
                });
            });
        },
    }
}